import { useCallback } from 'react';

declare global {
    interface Window {
        HubSpotConversations?: {
            widget: {
                load: () => void;
                open: () => void;
                remove: () => void;
            };
        };
    }
}

export const useToggleHubspotChat = () => {
    const openChat = useCallback(() => {
        if (typeof window !== 'undefined' && window.HubSpotConversations && window.HubSpotConversations.widget) {
            window.HubSpotConversations.widget.open();
        } else {
            console.warn('HubSpot Conversations widget not loaded.');
        }
    }, []);

    return { openChat };
};
export default useToggleHubspotChat;
